

<template>
  <div>
    <div class="header p-4 d-flex justify-content-between">
      <h3 class="m-0 p-0">{{ title }}</h3>
      <div class="clickable" @click="$emit('close')">
        <iconClose class="icon icon-close"></iconClose>
      </div>
    </div>
    <div class="px-4 pb-4">
      <p class="mb-1"> {{ $t('pages.campingCardACSIInfo.infotitle', {campgroundName: campgroundName,})}} </p>
      <div v-for="item in content" :key="item.year">
        <b v-if="content.length > 1">{{item.year}} </b>
        <ul class="mb-1">
          <li v-for="period in item.periods" :key="period.start_date">
            {{ $t('pages.campingCardACSIInfo.period', {
              startDate: period.start_date,
              endDate: period.end_date,
              duration: period.duration,
            })}}
          </li>
        </ul>
        <p>{{ $t(`pages.campingCardACSIInfo.ratePerNight`, {rate: formatRate(item.rate, item.currency) }) }} </p>
        <div v-if="item.free_nights && item.free_nights.length > 0">
          <b>{{ $t(`pages.campingCardACSIInfo.freeNights`) }}</b>
          <ul>
            <li v-for="freeNight in item.free_nights" :key="freeNight.description">
              {{ freeNight.description }}
            </li>
          </ul>
        </div>
      </div>
      <b>{{ $t(`pages.campingCardACSIInfo.includedTitle`) }}</b>
      <ul>
        <li v-for="(item, index) in $t(`pages.campingCardACSIInfo.extras`)" :key="index">
            {{ item }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import iconClose from '@/assets/icons/close-dark.svg'

export default {
  name: 'CiCampingCareAcsiInfoModal',

  components: {
    iconClose,
  },

  props: {
    title: {
      type: String,
      default: '',
    },

    campgroundName: {
      type: String,
      default: '',
    },

    content: {
      type: Array,
      default: () => [],
    },

    language: {
      type: Object,
      required: true,
    },

    currency: {
      type: Object,
      required: true,
    },
  },

  methods: {
    formatRate(rate, rateCurrencyCode) {
      return this.$options.filters.currency(
        rate,
        rateCurrencyCode,
        this.language.code
      )
    },
  },
}
</script>
